import { render, staticRenderFns } from "./VPSPwdLessLogin.vue?vue&type=template&id=b04fff56&scoped=true"
import script from "./VPSPwdLessLogin.vue?vue&type=script&lang=js"
export * from "./VPSPwdLessLogin.vue?vue&type=script&lang=js"
import style0 from "./VPSPwdLessLogin.vue?vue&type=style&index=0&id=b04fff56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04fff56",
  null
  
)

export default component.exports